var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_90_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 36C16.5 24.7643 16.5 19.1465 19.1965 15.1109C20.3638 13.3638 21.8638 11.8638 23.6109 10.6965C27.6465 8 33.2643 8 44.5 8C55.7357 8 61.3535 8 65.3891 10.6965C67.1362 11.8638 68.6362 13.3638 69.8035 15.1109C72.5 19.1465 72.5 24.7643 72.5 36C72.5 47.2357 72.5 52.8535 69.8035 56.8891C68.6362 58.6362 67.1362 60.1362 65.3891 61.3035C61.3535 64 55.7357 64 44.5 64C33.2643 64 27.6465 64 23.6109 61.3035C21.8638 60.1362 20.3638 58.6362 19.1965 56.8891C16.5 52.8535 16.5 47.2357 16.5 36Z",
    fill: "url(#paint0_linear_90_1305)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4867 25.8401C43.4867 24.7627 43.0587 23.7294 42.2969 22.9676C41.5351 22.2058 40.5019 21.7778 39.4245 21.7778H34.3401C33.2627 21.7778 32.2294 22.2058 31.4676 22.9676C30.7058 23.7294 30.2778 24.7627 30.2778 25.8401V30.9156C30.2778 31.993 30.7058 33.0262 31.4676 33.788C32.2294 34.5498 33.2627 34.9778 34.3401 34.9778H41.4512C41.991 34.9778 42.5088 34.7634 42.8905 34.3816C43.2723 33.9999 43.4867 33.4821 43.4867 32.9423V25.8312V25.8401Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5134 25.8399C45.5134 24.7626 45.9414 23.7293 46.7032 22.9675C47.465 22.2057 48.4983 21.7777 49.5756 21.7777H54.6512C55.1854 21.7766 55.7146 21.8808 56.2085 22.0844C56.7024 22.288 57.1512 22.587 57.5294 22.9644C57.9075 23.3417 58.2076 23.7899 58.4123 24.2833C58.617 24.7768 58.7223 25.3057 58.7223 25.8399V30.9155C58.7223 31.9929 58.2943 33.0261 57.5325 33.7879C56.7707 34.5497 55.7375 34.9777 54.6601 34.9777H47.549C47.0091 34.9777 46.4914 34.7633 46.1096 34.3815C45.7279 33.9998 45.5134 33.482 45.5134 32.9422V25.8311V25.8399Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4867 46.16C43.4867 47.2373 43.0587 48.2706 42.2969 49.0324C41.5351 49.7942 40.5019 50.2222 39.4245 50.2222H34.3401C33.2627 50.2222 32.2294 49.7942 31.4676 49.0324C30.7058 48.2706 30.2778 47.2373 30.2778 46.16V41.0755C30.2778 39.9982 30.7058 38.9649 31.4676 38.2031C32.2294 37.4413 33.2627 37.0133 34.3401 37.0133H41.4512C41.991 37.0133 42.5088 37.2278 42.8905 37.6095C43.2723 37.9912 43.4867 38.509 43.4867 39.0489V46.16Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5134 46.16C45.5134 47.2373 45.9414 48.2706 46.7032 49.0324C47.465 49.7942 48.4983 50.2222 49.5756 50.2222H54.6512C55.1854 50.2234 55.7146 50.1192 56.2085 49.9155C56.7024 49.7119 57.1512 49.4129 57.5294 49.0355C57.9075 48.6582 58.2076 48.21 58.4123 47.7166C58.617 47.2231 58.7223 46.6942 58.7223 46.16V41.0755C58.7223 39.9982 58.2943 38.9649 57.5325 38.2031C56.7707 37.4413 55.7375 37.0133 54.6601 37.0133H47.549C47.0091 37.0133 46.4914 37.2278 46.1096 37.6095C45.7279 37.9912 45.5134 38.509 45.5134 39.0489V46.16Z",
    fill: "#D3A837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_1305",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.658824 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_1305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_1305",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_1305",
    x1: 44.5,
    y1: 8,
    x2: 44.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.10a626c8991a20c5e92ec7f32262b54b.svg";
export { ForwardRef as ReactComponent };